import { api } from '@/services/api';
import type { Role } from '@/lib/role';

export interface UserProfileResponse {
  id: string;
  email: string;
  name: string;
  role: Role;
  diagnosticLevel?: string;
  createdAt: string;
}

export interface UpdateMyProfilePayload {
  name?: string;
  email?: string;
}

export async function getMyProfile() {
  const response = await api.get<UserProfileResponse>('/users/me');
  return response.data;
}

export async function updateMyProfile(payload: UpdateMyProfilePayload) {
  const response = await api.patch<UserProfileResponse>('/users/me', payload);
  return response.data;
}
